const brand = {
  bg: "#0E1116",
  surface: "#171A21",
  text: "#E6E9EF",
  muted: "#A6B0BF",
  accent: "#12D6D6",
  "accent-600": "#0FB9B9",
  "accent-700": "#0A8E8E",
  ring: "#7DE9E9",
  info: "#3B82F6",
  success: "#10B981",
  warning: "#F59E0B",
  danger: "#EF4444",
} as const;

const product = {
  bg: "#FFFFFF",
  surface: "#F7FAFC",
  text: "#0B1220",
  muted: "#55607A",
  accent: "#12D6D6",
  ring: "#0FB9B9",
  info: "#2563EB",
} as const;

export const palette = { brand, product } as const;

export const theme = {
  dark: {
    bg: "var(--brand-bg)",
    surface: "var(--brand-surface)",
    text: "var(--brand-text)",
    muted: "var(--brand-muted)",
    accent: "var(--brand-accent)",
    "accent-600": "var(--brand-accent-600)",
    "accent-700": "var(--brand-accent-700)",
    ring: "var(--brand-ring)",
    info: "var(--brand-info)",
    success: "var(--brand-success)",
    warning: "var(--brand-warning)",
    danger: "var(--brand-danger)",
  },
  light: {
    bg: "var(--product-bg)",
    surface: "var(--product-surface)",
    text: "var(--product-text)",
    muted: "var(--product-muted)",
    accent: "var(--product-accent)",
    "accent-600": "var(--brand-accent-600)",
    "accent-700": "var(--brand-accent-700)",
    ring: "var(--product-ring)",
    info: "var(--product-info)",
    success: "var(--brand-success)",
    warning: "var(--brand-warning)",
    danger: "var(--brand-danger)",
  },
} as const;

export const colors = {
  brand: Object.fromEntries(
    Object.keys(brand).map((key) => [key, `var(--brand-${key})`]),
  ) as Record<keyof typeof brand, string>,
  product: Object.fromEntries(
    Object.keys(product).map((key) => [key, `var(--product-${key})`]),
  ) as Record<keyof typeof product, string>,
  ...Object.fromEntries(Object.keys(theme.dark).map((key) => [key, `var(--color-${key})`])),
} as const;
